import { NativeModules } from 'react-native';
import { useMemoizedFn } from 'ahooks';

/**
 * @deprecated 请使用手势冲突组件替换
 * 设置容器右滑关闭，如果是spa场景，请使用useSpaSlideBack
 */
export function useSlideBack() {
    const setSlideBack = useMemoizedFn((initialEnable: number | boolean = true) => {
        // 只有路由为1的时候才处理容器，否则不处理容器
        if (initialEnable) {
            NativeModules?.KRNBasic?.setSlideBack?.({
                enabled: true, //  true: 打开滑动返回  false ：关闭滑动返回
            });
            console.log('打开右滑关闭容器');
        } else {
            NativeModules?.KRNBasic?.setSlideBack?.({
                enabled: false, //  true: 打开滑动返回  false ：关闭滑动返回
            });
            console.log('关闭右滑关闭容器');
        }
    });

    return {
        setSlideBack,
    };
}
